  

  WebFont.load({
  //   monotype: {
  //   projectId: 'cb32bc7b-6533-4948-bedd-77ddb37bdd34',
  //   version: 12345, // (optional, flushes the CDN cache)
  //   loadAllFonts: true //(optional, loads all project fonts)
  // }
    google: {
      families: ['Roboto Condensed:700', 'Poppins:300,600']
    }
  });